import jqRequest from '../jqRequest'
import advertsUrls from '../urls/adverts'

export default {
  // 获取占位广告内容
  getPlAdInfo(data){
    return jqRequest.requestWithToken(advertsUrls.getPlAdInfo, data);
  },
}